import ServiceDetail from "@/components/ServiceDetail";
import { MASONRY_SERVICE } from "@/data/masonry-service";

// NEW residential service page: brickwork, parging, foundation repair, underpinning.
export default function Masonry() {
    return <ServiceDetail data={MASONRY_SERVICE} track="residential" />;
}
